import { Dialog, DialogContent, DialogContentText, DialogActions, Button, DialogTitle } from "@mui/material";
import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { useTranslation } from "react-i18next";

const AlertDialog: React.FunctionComponent<{
    title: string;
    message: string;
    show: boolean;
    onClose?: () => void;
    testId?: string;
}> = (props) => {
    const [show, setShow] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        setShow(props.show);
    }, [props.show]);

    return <Dialog
        open={show}
        keepMounted
        onClose={() => setShow(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        data-testid={props.testId}
    >
        <DialogTitle>
            {props.title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">{props.message}</DialogContentText>
        </DialogContent>
        <DialogActions>

            <Button
                onClick={() => {
                    setShow(false);
                    if (props.onClose) {
                        props.onClose();
                    }
                }}
                color="primary"
                data-testid={props.testId ? `${props.testId}-ok-button` : undefined}
            ><b>{t("general.ok")}</b></Button>
        </DialogActions>
    </Dialog>
}

AlertDialog.propTypes = {
    title: propTypes.string.isRequired,
    message: propTypes.string.isRequired,
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired,
    testId: propTypes.string,
}

export default AlertDialog;